import styled, { css } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device, hexToRGB } from '@/styles/helpers';

interface ScSwitchLanguageButtonProps {
  variant?: 'full' | 'compact';
  $active: boolean;
}

interface ScSwitchLanguageProps {
  $active: boolean;
}

interface ScSwitchLanguageSelectProps {
  variant?: 'full' | 'compact';
}

const tickCircleGreenIcon = getCDNImageUrl('/icon-img/tickCircleIcon.svg');

export const ScSwitchLanguage = styled.div<ScSwitchLanguageProps>`
  position: relative;
  display: flex;
  width: max-content;
  z-index: ${({ $active }) => ($active ? 21 : 1)};

  @media (${device.mobile}) {
    z-index: ${({ $active }) => ($active ? 120 : 1)};
    width: 100%;
  }
`;

export const ScSwitchLanguageButton = styled.button<ScSwitchLanguageButtonProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  background: ${({ theme }) => theme.grayLightColor};
  border-radius: 24px;
  color: ${({ theme }) => theme.whiteColor};
  width: ${({ variant }) => (variant === 'full' ? '160px' : '84px')};
  height: ${({ variant }) => (variant === 'full' ? '40px' : '48px')};
  text-transform: uppercase;
  cursor: pointer;
  text-align: left;
  position: relative;
  padding: ${({ variant }) => (variant === 'full' ? '0 16px 3px' : '4px')};

  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.16px;

  @media (${device.mobileS}) {
    width: 100%;
  }

  @media (hover: hover) {
    &:hover {
      & > .arrow {
        i {
          color: ${({ theme }) => theme.whiteColor};
        }
      }
    }
  }

  & > .arrow {
    position: absolute;
    right: 16px;
    top: ${({ variant }) => (variant === 'full' ? '10px' : '18px')};
    
    i {
      display: block;
      transition: transform 0.2s;
      transform: ${({ $active, variant }) =>
        $active && variant === 'full' ? 'rotate(-90deg)' : 'rotate(90deg)'};
      color: ${({ $active, theme }) =>
        $active ? theme.whiteColor : theme.grayColor};
    }
  }

  & > .flag {
    img {
      border-radius: 50%;
      object-fit: cover;
      object-position: center;
    }
  }

  & > .value {
    margin-left: 8px;
    padding-top: 2px;
  }
`;

export const ScSwitchLanguageSelect = styled.div<ScSwitchLanguageSelectProps>`
  position: absolute;
  background: ${({ theme }) => theme.grayLightColor};
  border-radius: 24px;
  z-index: -1;
  padding: 16px;
  box-shadow: 0px 2px 10px 0px ${({ theme }) => hexToRGB(theme.blackColor, 0.9)};
  width: 160px;

  ${({ variant }) =>
    variant === 'full'
      ? css`
          left: 0;
          right: 0;
          bottom: 0;
          margin-bottom: 44px;
        `
      : css`
          top: 52px;
          right: 0;
        `}

  button,
  a {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border: none;
    background: none;
    color: ${({ theme }) => theme.blackLightColor};
    text-transform: uppercase;
    text-align: left;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    transition: 0.2s;
    padding-right: 24px;
    position: relative;
    padding-top: 4px;
    padding-bottom: 4px;

    .tick-circle-icon {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 0;
         background: ${() => `url(${tickCircleGreenIcon}) center no-repeat`};
    }

    &.active {
      color: ${({ theme }) => theme.whiteColor};
    }

    @media (${device.mobile}) {
      color: ${({ theme }) => theme.whiteColor};
    }

    &:hover {
      color: ${({ theme }) => theme.whiteColor};
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    img {
      border-radius: 50%;
      margin-right: 8px;
      object-fit: cover;
      object-position: center;
    }
  }
`;
